/**
 * Development-only logger. Use instead of raw console.* in application code.
 */

type LogArgs = unknown[];

function isDev(): boolean {
  return import.meta.env.DEV;
}

export const devLog = (...args: LogArgs): void => {
  if (isDev()) {
    // eslint-disable-next-line no-console
    console.log(...args);
  }
};

export const devWarn = (...args: LogArgs): void => {
  if (isDev()) {
    // eslint-disable-next-line no-console
    console.warn(...args);
  }
};

export const devError = (...args: LogArgs): void => {
  if (isDev()) {
    // eslint-disable-next-line no-console
    console.error(...args);
  }
};

export const devTrace = (...args: LogArgs): void => {
  if (isDev()) {
    // eslint-disable-next-line no-console
    console.trace(...args);
  }
};

/** Silence console noise in production builds (ErrorBoundary keeps user-safe UI). */
export function setupProductionConsole(): void {
  if (isDev()) return;
  const noop = () => {};
  // eslint-disable-next-line no-console
  console.log = noop;
  // eslint-disable-next-line no-console
  console.warn = noop;
  // eslint-disable-next-line no-console
  console.error = noop;
}
